import React from "react";
import { Grid, Typography } from "@mui/material";
import { VehicleTextField } from "../VehicleFormFields";

const DispatchTab: React.FC = () => {
  return (
    <>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Assign dispatch responsibilities and organize vehicles by operational groups.
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <VehicleTextField 
            name="dispatcher" 
            label="Dispatcher" 
            placeholder="Dispatcher name"
            tooltip="Primary dispatcher assigned to this vehicle"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <VehicleTextField 
            name="dispatchGroup" 
            label="Dispatch Group" 
            placeholder="e.g., Local, Regional, OTR"
            tooltip="Operational group for dispatch purposes"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <VehicleTextField 
            name="dispatchCategory" 
            label="Dispatch Category" 
            placeholder="e.g., Refrigerated, Dry Van"
            tooltip="Category of freight this vehicle typically handles"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default DispatchTab;
